var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import ResponsiveImage from "./ResponsiveImage.vue";
import Testimonial from "./Testimonial.vue";
import Breadcrumb from "bootstrap-vue/es/components/breadcrumb/breadcrumb";
import BreadcrumbItem from "bootstrap-vue/es/components/breadcrumb/breadcrumb-item";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import Carousel from 'bootstrap-vue/es/components/carousel/carousel';
import CarouselSlide from 'bootstrap-vue/es/components/carousel/carousel-slide';
import { parseImageCropDataSet } from "../Helpers/Image.ts";
var Cover = /** @class */ (function (_super) {
    __extends(Cover, _super);
    function Cover() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.breadcrumbs = [];
        _this.randomTestimonials = undefined;
        _this.testimonial1 = null;
        _this.testimonial2 = null;
        _this.testimonialHandle = undefined;
        return _this;
    }
    Object.defineProperty(Cover.prototype, "hrVisible", {
        get: function () {
            if (this.showHr === true || this.showHr === false)
                return this.showHr;
            return this.shortDescription && this.longDescription;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Cover.prototype, "imagesArray", {
        get: function () {
            if (!this.images)
                return [];
            if (this.images instanceof Array)
                return this.images.map(function (p) { return parseImageCropDataSet(p); });
            return [parseImageCropDataSet(this.images)];
        },
        enumerable: true,
        configurable: true
    });
    Cover.prototype.mounted = function () {
        window.$bus.$on("BreadcrumbAnchor.mounted", this.refreshBreadcrumbs);
        window.$bus.$on("BreadcrumbAnchor.unmounted", this.refreshBreadcrumbs);
        this.refreshBreadcrumbs();
        this.setupTestimonials();
    };
    Cover.prototype.destroyed = function () {
        window.$bus.$off("BreadcrumbAnchor.mounted", this.refreshBreadcrumbs);
        window.$bus.$off("BreadcrumbAnchor.unmounted", this.refreshBreadcrumbs);
        if (this.testimonialHandle) {
            clearInterval(this.testimonialHandle);
        }
    };
    Cover.prototype.refreshBreadcrumbs = function () {
        this.breadcrumbs = this.$root.$el.querySelectorAll("[breadcrumb-title][id]");
    };
    Cover.prototype.carouselSliding = function () {
        this.transitionTestimonial();
    };
    Cover.prototype.setupTestimonials = function () {
        if (this.testimonials.length === 0)
            return;
        if (this.testimonials.length === 1) {
            this.testimonial1 = this.testimonials[0];
            return;
        }
        this.testimonial1 = this.getRandomTestimonial();
        // Only set up timer if there is not a carousel. Otherwise, transitions will be handled
        // by carousel events.
        //
        if (!this.$refs.carousel) {
            this.testimonialHandle = setInterval(this.transitionTestimonial.bind(this), 5000);
        }
    };
    Cover.prototype.transitionTestimonial = function () {
        if (this.testimonial1) {
            this.testimonial1 = null;
            this.testimonial2 = this.getRandomTestimonial();
        }
        else {
            this.testimonial2 = null;
            this.testimonial1 = this.getRandomTestimonial();
        }
    };
    Cover.prototype.getRandomTestimonial = function () {
        if (this.testimonials.length === 0)
            return null;
        if (this.testimonials.length === 1)
            return this.testimonials[0];
        if (!this.randomTestimonials || this.randomTestimonials.length === 0) {
            this.randomTestimonials = this.testimonials.shuffle();
        }
        return this.randomTestimonials.pop();
    };
    __decorate([
        Prop({ type: String })
    ], Cover.prototype, "title", void 0);
    __decorate([
        Prop({ type: String })
    ], Cover.prototype, "shortDescription", void 0);
    __decorate([
        Prop({ type: String })
    ], Cover.prototype, "longDescription", void 0);
    __decorate([
        Prop({ type: Boolean, default: undefined })
    ], Cover.prototype, "showHr", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Cover.prototype, "hashtags", void 0);
    __decorate([
        Prop({ type: [Array, String, Object], default: function () { return []; } })
    ], Cover.prototype, "images", void 0);
    __decorate([
        Prop({ type: Array, default: function () { return []; } })
    ], Cover.prototype, "testimonials", void 0);
    Cover = __decorate([
        Component({
            name: "Cover",
            components: {
                ResponsiveImage: ResponsiveImage,
                Testimonial: Testimonial,
                "b-row": Row,
                "b-col": Col,
                "b-breadcrumb": Breadcrumb,
                "b-breadcrumb-item": BreadcrumbItem,
                "b-carousel": Carousel,
                "b-carousel-slide": CarouselSlide
            }
        })
    ], Cover);
    return Cover;
}(Vue));
export default Cover;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/Cover.vue
// module id = 10
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18